import { queryOptions } from "@tanstack/react-query";
import { authTokenRefresh, getAuthInfo } from "../v1/auth.service";

const REFRESH_INTERVAL = 1000 * 60 * 15;

export const useAuthInfo = () =>
  queryOptions({
    queryKey: ["auth-info"],
    queryFn: () => getAuthInfo(),
    staleTime: 1000 * 60 * 5,
    retry: 1,
  });

export const useAuthRefresh = (refreshToken: string) =>
  queryOptions({
    queryKey: ["modusj-accessToken"],
    queryFn: () => authTokenRefresh(refreshToken),
    staleTime: REFRESH_INTERVAL,
    refetchInterval: REFRESH_INTERVAL,
    retry: 1,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
